(function () {
  const PUBLIC_PADDLE_TOKEN = "test_5add5377efb75d0051ca9ddb800";
  const PUBLIC_PADDLE_ENV = "sandbox";
  const PUBLIC_PADDLE_PRICE_MONTHLY = "pri_01ke6xtsnn6c3v49t20sk5a0qt";
  const PUBLIC_PADDLE_PRICE_ANNUAL = "pri_01ke6xrndh26t3nppx398etkyf";
  const PUBLIC_PADDLE_PRICE_LIFETIME = "pri_01ke6xxs8vpggdh29977zv6f77";

  async function localInit() {
    Paddle.Environment.set(PUBLIC_PADDLE_ENV);
    Paddle.Initialize({
      token: PUBLIC_PADDLE_TOKEN,
    });
  }

  /**
   * @param {string} priceId
   * @param {string|undefined} currencyCode
   */
  async function getPriceInfo(priceId, currencyCode) {
    const request = {
      items: [
        {
          quantity: 1,
          priceId: priceId,
        },
      ],
    };

    if (currencyCode) {
      request["currency_code"] = currencyCode;
    }

    const response = await Paddle.PricePreview(request);
    console.log(JSON.stringify(response, undefined, 2));
    const lineItem = response["data"]["details"]["lineItems"][0];
    /** @type {string} */
    const total = lineItem["formattedTotals"]["total"];
    /** @type {string[]} */
    const paymentMethods = response["data"]["availablePaymentMethods"];
    return {
      total,
      paymentMethods,
    };
  }

  /**
   * Finds all the elements whose content need to be updated.
   * @param {HTMLElement} el The HTML element whose values need to be updated */
  function getOutputElements(el) {
    /** @param {string} key
     * @returns {NodeListOf<HTMLElement>} */
    function find(key) {
      const attr = "data-pricing-output";
      return el.querySelectorAll(`[${attr}="${key}"]`);
    }

    const payment = find(`payment`);
    const price = find(`price`);

    return {
      payment,
      price,
    };
  }
  /** @param {HTMLElement} el The HTML element whose values need to be updated */

  async function updatePriceCard(el) {
    const priceId = el.getAttribute("data-pricing");
    const priceInfo = await getPriceInfo(priceId);
    const output = getOutputElements(el);

    // Set the price string
    output.price.forEach((e) => (e.innerText = priceInfo.total));
    // TODO: Toggle which icons can be shown.
  }

  function loadPaddle() {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.onload = function () {
      localInit().then(() => {
        for (const el of document.querySelectorAll("[data-pricing]")) {
          updatePriceCard(el);
        }
      });
    };
    script.onerror = function () {
      console.error("Failed to load script");
    };
    document.head.appendChild(script);
  }

  // Once the document is loaded, scan for the price information.
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelectorAll("[data-pricing]").length > 0) {
      loadPaddle();
    }
  });
})();
